module.exports = __webpack_public_path__ + "static/media/insurance_2.1cfe8d9f.svg";